import React, { useState, useEffect } from "react";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";

import { InputText } from "primereact/inputtext";
import {
  FaClipboardList,
  FaMapMarkedAlt,
  FaList,
  FaBuilding,
  FaNewspaper,
  FaClipboardCheck,
  FaQuestionCircle,
  FaRegEnvelopeOpen,
  FaArrowLeft,
  FaPlay
} from "react-icons/fa";
import axios from "axios";
import NousContacter from "../NousContacterConnected";
import { Dialog } from "primereact/dialog";
// import { SidebarData } from "./SidebarData";
import { NavLink } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import "./sideBar.css";
import { useNavigate,useLocation } from "react-router-dom";
import { Sidebar } from 'primereact/sidebar';
import { instance } from "../../api";
import { useClient } from "../../Context/ClientContext";
// import { useUser } from "../../Context/UserContext";
// import api from "../../api";
import { adminUser } from "../NavBar/navBar";
import { FaTimes } from "react-icons/fa";

export default function SideBar({setVisible , visible , setSearch ,}) {
  const navigate = useNavigate();
  const location = useLocation();

  const {client , selectedClient}=useClient()
  const [searchQuery, setSearchQuery] = useState(""); // Pour capturer la recherche de l'utilisateur
  const [searchInput, setSearchInput] = useState(""); // State to store search input
  const [enabledSteps, setEnabledSteps] = useState(false);
  const onExit = () => {
    setEnabledSteps(false);
  };

  
 // const {user} = useUser();
const clientTableau = Object.values(client);

const [isAdmin, setIsAdmin] = useState(false);
const [isInvite, setIsInvite] = useState(false);


const checkAdminRole = () => {
  if (!selectedClient || !clientTableau.length) {
    setIsAdmin(false);
    setIsInvite(false)
    return;
  }

  // Find the selected client's roles
  const clientData = clientTableau.find(
    (client) => client.id_client_gexpertise === selectedClient
  );

  if (clientData && clientData.role) {
    const role = clientData.role.toLowerCase();
    setIsAdmin(role === "utilisateur");
    setIsInvite(role === "invité");
  } else {
    setIsAdmin(false);
    setIsInvite(false);
  }
};

useEffect(() => {
  checkAdminRole();
}, [selectedClient, clientTableau]);

useEffect(() => {
 
}, [isAdmin, selectedClient, clientTableau]);

useEffect(() => {
  const searchQuery = new URLSearchParams(location.search).get("search") || "";
  setSearchInput(searchQuery); 
}, [location.search]);
  
  const sideBarSteps=[
  
      {
        element: "#maps",
        intro: 'Cliquez sur un actif pour accéder aux livrables associés <img src="tuto_marker.PNG" width="75%" height="30%"/>',
        position: "top",
      },
      {
        element: ".searchBox",
        intro: "Recherchez un actif par mot clé ",
        position: "bottom",
      },
      {
        element: ".carto",
        intro: "Visualisez les actifs en mode cartographie ",
        position: "left",
      },
      {
        element: ".actifList",
        intro: "Visualisez les actifs en mode liste",
        position: "left",
      },
      {
        element: ".portail",
        intro: "Accédez au Portail urbanisme du Groupe Gexpertise",
        position: "left",
      },
      {
        element: ".NameLastName",
        intro: "Accédez à votre profil et à la liste des utilisateurs qui ont accès au compte GexOnline",
        position: "right",
      },
      {
        element: ".nousContacter",
        intro: "Contactez nous via les formulaires disponibles",
        position: "right",
      },
    
  ]

  const [openDialog, setDialog] = useState(false);

  const onClickOpen = () => {
    setDialog(true);
  };
  const onHide = () => {
    setDialog(false);
  };

  
  const onRedirectClick = () => {
    const formData = new FormData();
    const date = new Date();
    formData.append("date", date.toISOString().replace("T", " ").split(".")[0]);
    formData.append("redirect", "/my");
    formData.append("msg", createUUID(date));

    try {
      instance
        .post(
          "/api/redirection",
          formData
        )
        .then((data) => {
          const config = {
            headers: {
              Authorization: "Bearer " + data.data.token,
              Accept: "text/html",
              "X-HMAC-TOKEN": data.data.hmac,
              "X-MESSAGE-ID": formData.get("msg").toString(),
              "content-type": "multipart/form-data",
            },
            responseType: "text",
            withCredentials: true,
          };
          //formData.delete("msg");
          axios
            .post(
              "https://odoo.gexpertise.fr/api/auth/gex_signin",
              // "https://recette5.simplicit.eu/api/auth/gex_signin",
              // "https://odoo-r7.gexpertise.fr/api/auth/gex_signin",
              formData,
              config
            )
            // .then(() => window.open(`https://recette5.simplicit.eu/my`))
            // .then(() => window.open(`https://odoo-r7.gexpertise.fr/shop`))
            //.then(() => window.open(`https://odoo.gexpertise.fr/my`))
              .then(() => {
  // Ouvrir un nouvel onglet et forcer la navigation vers /my
  const newTab = window.open('about:blank', '_blank');
  newTab.location.href = `https://odoo.gexpertise.fr/my`;
})
            .catch((error) => {
             
            });
        });
    } catch (failed) {
      
    }
  };
  const createUUID = () => {
    var date = new Date();
    var dt = date.getTime();
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
    return uuid;
  };

  const SidebarData = [
    {
      title: <span className="carto"> Cartographie des actifs</span>,
      path: "/carte",
      icon: (
        <FaMapMarkedAlt
          style={{ width: "20", height: "20" }}
          className="icon"
        />
      ),
    },
    {
      title: <span className="actifList" > Liste des actifs </span>,
      path: "/Liste",
      icon: <FaList style={{ width: "20", height: "20" }} className="icon" />,
    },
    {
      title: <span className="portail" style={{color:'black'}}>Portail Urbanisme</span>,
       path: "/my",
      icon: (
        <FaBuilding style={{ width: "20", height: "20" ,color:'black'}} className="icon" />
      ),
    },

    {
      title: <span className="actualites">Fil d'actualité</span>,
      path: "/News",
      icon: (
        <FaNewspaper style={{ width: "20", height: "20" }} className="icon" />
      ),
    },
    
    
    {
      title: " Groupe Gexpertise",
      icon: (
        <FaNewspaper style={{ width: "20", height: "20" }} className="icon" />
      ),
    },

    {
      title: <span className="nousContacter1"> Nous contacter</span>,
      icon: (
        <FaRegEnvelopeOpen
          style={{ width: "20", height: "20" }}
          className="icon"
        />
      ),
      path: "",
      command: () => {
        setDialog(true);
      },
    },
    {
      title: (
        <span  style={{ color: "black" }}>Lancer le didacticiel</span>
      ), // Title for the tutorial button
      icon: (
        <FaPlay
          style={{ width: "20", height: "20", color: "black" }}
          className="icon"
        />
      ),
      command: () => {
        setEnabledSteps(true); // Trigger tutorial
      },
    },
    
    {
      title: <span className="FAQ">FAQ</span>,
      path: "/Faq",
      icon: (
        <FaQuestionCircle
          style={{ width: "20", height: "20" }}
          className="icon"
        />
      ),
    },
    {
      title: <span className="mlégale"> Mention légales </span>,
      path: "/MentionLegales",
      icon: (
        <FaClipboardCheck
          style={{ width: "20", height: "20" }}
          className="icon"
        />
      ),
    },
    {
      title: <span className="CGU">CGU</span>,
      path: "/CGU",
      icon: (
        <FaClipboardList
          style={{ width: "20", height: "20" }}
          className="icon"
        />
      ),
    },
  ];
 const serarchActif = (e) => {
  const value = e.target.value;
  setSearchInput(value);

  // Always update the URL, even if the search is empty
  const params = new URLSearchParams(location.search);
  if (value.trim()) {
    params.set("search", value.trim());
  } else {
    params.delete("search");
  }

  navigate(`/Liste?${params.toString()}`);
};
  const searchBox = (
    <div className="searchBox">
    
      <span className="p-input-icon-right">
    <i className="pi pi-search" />
    <InputText placeholder="Rechercher un actif"  value={searchInput}  onChange={serarchActif} 
    style={{ paddingRight: "30px" }} />
      </span>
      {searchInput && (
      <FaTimes
        style={{
         
          left: "210px",
          top: "4.5%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#DE0737",
        }}
        onClick={() => {
          setSearchInput(""); // Réinitialiser la barre de recherche
          navigate(`/Liste`); // Réinitialiser les résultats
        }}
      />
    )}
    </div>
    

  );
  const filteredSteps = sideBarSteps.filter(step => {
  // Supprime l'étape "Portail Urbanisme" si l'utilisateur est invité
  if (step.element === ".portail" && isInvite) {
    return false;
  }
  return true;
});


  return (
    <>  
    <Steps
        enabled={enabledSteps}
        steps={filteredSteps}
        initialStep={0}
        onExit={onExit}
        options={{
          nextLabel: "Suivant",
          prevLabel: "Précédent",
          doneLabel: "Terminer",
        }}
      />
    <Sidebar
  visible={visible}
  onHide={() => setVisible(false)}
  icons={
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      {/* Search Box */}
      <div className="searchBox" style={{ flex: 1 }}>
        <span className="p-input-icon-right">
          <i className="pi pi-search" />
          <InputText
            placeholder="Rechercher un actif"
            value={searchInput}
            onChange={serarchActif}
            style={{ paddingRight: "30px", width: "100%" }}
          />
          {searchInput && (
      <FaTimes
        style={{
         
          left: "180px",
          top:"30px",
          bottom:"200px",
          position:"",
          
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#DE0737",
        }}
        onClick={() => {
          setSearchInput(""); // Réinitialiser la barre de recherche
          navigate(`/Liste`); // Réinitialiser les résultats
        }}
      />
    )}
        </span>
      </div>

      {/* Custom Close Button */}
      <button
  type="button"
  className="custom-close-button"
  onClick={() => setVisible(false)}
  title="Masquer le contenu"
 
  style={{
    background: "#f0f4ff", // Light blue background
    border: "2px solid #d0dafb", // Border color matching the background
    borderRadius: "50%", // Make it circular
    width: "40px", // Width of the button
    height: "40px", // Height of the button
    display: "flex", // Use flexbox to center the arrow
    justifyContent: "center", // Center horizontally
    alignItems: "center", // Center vertically
    color: "#333", // Arrow color
    cursor: "pointer",
    transition: "all 0.3s ease", // Smooth hover effects
  }}
  
>
  <FaArrowLeft style={{fontSize: "20px" }} />
</button>

      
    </div>
  }
>
    

      <div className=" container sideBare">
      
      {SidebarData.map((item, index) => {
        if (item.path) {
        
        
          return (
            <div key={index}>
              {index !== 6 && index !== 7 && index !== 2 && (
                <NavLink to={item.path} className="Link">
                  <div className="link-item pages">
                    <span>{item.icon}</span>
                    <span className="Title-item">{item.title}</span>
                  </div>
                </NavLink>
              )}
              {index === 7 && (
               
                <NavLink to={item.path} className="Link">
                  <div className="link-item pages">
                    <span>{item.icon}</span>
                    <span className="Title-item">{item.title}</span>
                  </div>
                </NavLink>
              )}
               {/*<div className="link-item site" onClick={onClickOpen}>
                  <span>{item.icon}</span>
                  <span className="Title-item">{item.title}</span>
                </div>*/}
            { adminUser(clientTableau, selectedClient) !== undefined && index === 2 && (
  <div
    className="link-item"
    onClick={() => {
     
      onRedirectClick();
    }}
    style={{ cursor: "pointer" }}
  >
    <span>{item.icon}</span>
    <span className="Title-item">{item.title}</span>
  </div>
)}



               

              {index === 6 && (
                <div className="link-item gex">
                  <span>{item.icon}</span>
                  <span className="Title-item">
                    <a
                      style={{ color: "#000000 !important" }}
                      href="https://gexpertise.fr/"
                      id="redirectionlink"
                      target="_blank"
                    >
                      {item.title}
                    </a>
                  </span>
                </div>
              )}
            </div>
          )};
          if (item.command) {
            // For command-based items (e.g., tutorial button)
            return (
              <div
                key={index}
                className="link-item"
                onClick={item.command}
                style={{ cursor: "pointer" }}
              >
                {item.icon && <span>{item.icon}</span>}
                <span className="Title-item">{item.title}</span>
              </div>
            );
          }
        }
        )}
        

        <h1> </h1>
      </div>
      </Sidebar>
     
      <Dialog
        header="Contactez-nous"
        visible={openDialog}
        style={{ width: "50vw" }}
        onHide={() => onHide("openDialog")}
      >
        <NousContacter setDialog={setDialog}  />
      </Dialog>
    </>
  );
}

